import { render } from "./QuotesUnfulfilledPurchasesPage.vue?vue&type=template&id=03548072"
import script from "./QuotesUnfulfilledPurchasesPage.vue?vue&type=script&lang=js"
export * from "./QuotesUnfulfilledPurchasesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__